import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import "./assets/css/spacing.css"

import { store, persistor } from "./store"
import { setupAuthInterceptors } from "utils/authInterceptors"
import { setupImageFallback } from "utils/imageFallback"

// Before the first render, so requests fired from pages' mount effects get the token / 401 handling
setupAuthInterceptors()
setupImageFallback()

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.Fragment>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </PersistGate>
  </Provider>
)

serviceWorker.unregister()
